export const name = 'gzGoogleMap';
export default function gzGoogleMap(
  $gzGoogleMaps,
  $state,
  $window,
  $rootScope
) {
  'ngInject';

  const directive = {
    restrict: 'EA',
    scope: {
      pairingId: '@?',
      options: '=?',
      onMapClicked: '&?',
      awaitLocation: '=?',
    },
    template: require('./google-map.jade'),
    controllerAs: 'vm',
    bindToController: true,
    link: gzGoogleMapLink,
    controller: gzGoogleMapController,
  };
  return directive;

  function gzGoogleMapLink(scope, element) {
    scope.$on('$destroy', () => {
      // Ensure map instance removed
      $gzGoogleMaps.mapRemoved(scope.vm.pairingId);
    });

    // if (scope.vm.awaitLocation) {
    //   element[0].classList.add('awaiting-location');
    // }

    return $gzGoogleMaps.onReady().then(() => {
      let map = new $window.google.maps.Map(element.children()[0], {
        // TODO: pass options through attributes
        center: {lat: 0, lng: 0},
        zoom: 1,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
      });

      // if (scope.vm.awaitLocation) {
      //   map.addListener('center_changed', () => {
      //     element[0].classList.remove('awaiting-location');
      //   });
      // }

      let geocoder = new $window.google.maps.Geocoder();

      $gzGoogleMaps.mapAdded(scope.vm.pairingId, map);

      if (scope.vm.onMapClicked) {
        let clickHandler = _.debounce(event => {
          if (map.getZoom() < 16) {
            return;
          }

          geocoder.geocode({'latLng': event.latLng}, (results, status) => {
            if (status === $window.google.maps.GeocoderStatus.OK && results[0]) {
              $rootScope.$applyAsync(() => {
                scope.vm.onMapClicked({$place: results[0]});
              });
            }
          });
        }, 400);
        $window.google.maps.event.addListener(map, 'click', clickHandler);
        $window.google.maps.event.addListener(map, 'dblclick', clickHandler.cancel);
      }

      return map;
    });
  }

  // @ngInject
  function gzGoogleMapController() {
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/google-maps/google-map.directive.js